export default __webpack_public_path__ + "static/media/Telugu_dm_2.7c691e04.mp3";